export let InitializationType = /*#__PURE__*/function (InitializationType) {
  InitializationType["All"] = "ALL";
  InitializationType["CardList"] = "CARD_LIST";
  InitializationType["PrintableCheckAccess"] = "PRINTABLE_CHECK_ACCESS";
  return InitializationType;
}({});

// Action
// =============================================================================
export let Action;
(function (_Action) {
  let Type = /*#__PURE__*/function (Type) {
    Type["ReceivedBalances"] = "ReceivedBalances";
    Type["ReceivedBillPayData"] = "ReceivedBillPayData";
    Type["ReceivedBootstrapCreatePrintableCheck"] = "ReceivedBootstrapCreatePrintableCheck";
    Type["ReceivedCreatePrintableCheck"] = "ReceivedCreatePrintableCheck";
    Type["ReceivedDirectDepositAccount"] = "ReceivedDirectDepositAccount";
    Type["ReceivedDownloadPrintableCheck"] = "ReceivedDownloadPrintableCheck";
    Type["ReceivedPrintableCheckAccess"] = "ReceivedPrintableCheckAccess";
    Type["RequestBalances"] = "RequestBalances";
    Type["RequestBillPayData"] = "RequestBillPayData";
    Type["RequestBootstrapCreatePrintableCheck"] = "RequestBootstrapCreatePrintableCheck";
    Type["RequestCreatePrintableCheck"] = "RequestCreatePrintableCheck";
    Type["RequestDownloadPrintableCheck"] = "RequestDownloadPrintableCheck";
    Type["RequestPrintableCheckAccess"] = "RequestPrintableCheckAccess";
    Type["SystemCheckHideEducation"] = "SystemCheckHideEducation";
    Type["SystemDisableToggle"] = "SystemDisableToggle";
    Type["SystemInitialize"] = "SystemInitialize";
    Type["SystemPromptAuthCodeInput"] = "SystemPromptAuthCodeInput";
    Type["SystemReceivedAuthDecision"] = "SystemReceivedAuthDecision";
    Type["SystemRefreshRecentActivities"] = "SystemRefreshRecentActivities";
    Type["SystemToggleAuthModal"] = "SystemToggleAuthModal";
    Type["SystemToggleResendButton"] = "SystemToggleResendButton";
    Type["SystemToggleShowAccountNumber"] = "SystemToggleShowAccountNumber";
    Type["UserChangeAuthCode"] = "UserChangeAuthCode";
    Type["UserClickContinueToWriteACheck"] = "UserClickContinueToWriteACheck";
    Type["UserClickCreatePrintableCheck"] = "UserClickCreatePrintableCheck";
    Type["UserClickDismissAuthModal"] = "UserClickDismissAuthModal";
    Type["UserClickDismissBillPayModal"] = "UserClickDismissBillPayModal";
    Type["UserClickDismissPrintableCheckBlade"] = "UserClickDismissPrintableCheckBlade";
    Type["UserClickDismissPrintableCheckModal"] = "UserClickDismissPrintableCheckModal";
    Type["UserClickDownloadCheck"] = "UserClickDownloadCheck";
    Type["UserClickHideEducation"] = "UserClickHideEducation";
    Type["UserClickOpenCreatePrintableCheck"] = "UserClickOpenCreatePrintableCheck";
    Type["UserClickPayBills"] = "UserClickPayBills";
    Type["UserClickPrintCheck"] = "UserClickPrintCheck";
    Type["UserClickResendCode"] = "UserClickResendCode";
    Type["UserClickShowEducation"] = "UserClickShowEducation";
    Type["UserClickStatementsAndDocuments"] = "UserClickStatementsAndDocuments";
    Type["UserClickSubmitAuthCode"] = "UserClickSubmitAuthCode";
    Type["UserClickUploadBill"] = "UserClickUploadBill";
    Type["UserClickWaitlist"] = "UserClickWaitlist";
    Type["UserToggleAccountDetails"] = "UserToggleAccountDetails";
    Type["UserUpdateCreatePrintableCheckRequest"] = "UserUpdateCreatePrintableCheckRequest";
    return Type;
  }({});
  _Action.Type = Type;
})(Action || (Action = {}));
// Action creators
// -----------------------------------------------------------------------------
export let ActionCreator;
(function (_ActionCreator) {
  const receivedBalances = _ActionCreator.receivedBalances = response => ({
    type: Action.Type.ReceivedBalances,
    response
  });
  const receivedBillPayData = _ActionCreator.receivedBillPayData = response => ({
    type: Action.Type.ReceivedBillPayData,
    response
  });
  const receivedBootstrapCreatePrintableCheck = _ActionCreator.receivedBootstrapCreatePrintableCheck = response => ({
    type: Action.Type.ReceivedBootstrapCreatePrintableCheck,
    response
  });
  const receivedCreatePrintableCheck = _ActionCreator.receivedCreatePrintableCheck = response => ({
    type: Action.Type.ReceivedCreatePrintableCheck,
    response
  });
  const receivedDirectDepositAccount = _ActionCreator.receivedDirectDepositAccount = response => ({
    type: Action.Type.ReceivedDirectDepositAccount,
    response
  });
  const receivedDownloadPrintableCheck = _ActionCreator.receivedDownloadPrintableCheck = response => ({
    type: Action.Type.ReceivedDownloadPrintableCheck,
    response
  });
  const receivedPrintableCheckAccess = _ActionCreator.receivedPrintableCheckAccess = response => ({
    type: Action.Type.ReceivedPrintableCheckAccess,
    response
  });
  const requestBalances = _ActionCreator.requestBalances = () => ({
    type: Action.Type.RequestBalances
  });
  const requestBillPayData = _ActionCreator.requestBillPayData = () => ({
    type: Action.Type.RequestBillPayData
  });
  const requestBootstrapCreatePrintableCheck = _ActionCreator.requestBootstrapCreatePrintableCheck = () => ({
    type: Action.Type.RequestBootstrapCreatePrintableCheck
  });
  const requestCreatePrintableCheck = _ActionCreator.requestCreatePrintableCheck = () => ({
    type: Action.Type.RequestCreatePrintableCheck
  });
  const requestDownloadPrintableCheck = _ActionCreator.requestDownloadPrintableCheck = printableCheckId => ({
    type: Action.Type.RequestDownloadPrintableCheck,
    printableCheckId
  });
  const requestPrintableCheckAccess = _ActionCreator.requestPrintableCheckAccess = () => ({
    type: Action.Type.RequestPrintableCheckAccess
  });
  const systemCheckHideEducation = _ActionCreator.systemCheckHideEducation = () => ({
    type: Action.Type.SystemCheckHideEducation
  });
  const systemDisableToggle = _ActionCreator.systemDisableToggle = () => ({
    type: Action.Type.SystemDisableToggle
  });
  const systemInitialize = _ActionCreator.systemInitialize = (unitToken, showPrintableCheckModal, initializationType = InitializationType.All) => ({
    type: Action.Type.SystemInitialize,
    unitToken,
    showPrintableCheckModal,
    initializationType
  });
  const systemPromptAuthCodeInput = _ActionCreator.systemPromptAuthCodeInput = onComplete => ({
    type: Action.Type.SystemPromptAuthCodeInput,
    onComplete
  });
  const systemReceivedAuthDecision = _ActionCreator.systemReceivedAuthDecision = response => ({
    type: Action.Type.SystemReceivedAuthDecision,
    response
  });
  const systemRefreshRecentActivities = _ActionCreator.systemRefreshRecentActivities = () => ({
    type: Action.Type.SystemRefreshRecentActivities
  });
  const systemToggleAuthModal = _ActionCreator.systemToggleAuthModal = toggle => ({
    toggle,
    type: Action.Type.SystemToggleAuthModal
  });
  const systemToggleResendButton = _ActionCreator.systemToggleResendButton = toggle => ({
    type: Action.Type.SystemToggleResendButton,
    toggle
  });
  const systemToggleShowAccountNumber = _ActionCreator.systemToggleShowAccountNumber = toggle => ({
    toggle,
    type: Action.Type.SystemToggleShowAccountNumber
  });
  const userChangeAuthCode = _ActionCreator.userChangeAuthCode = value => ({
    type: Action.Type.UserChangeAuthCode,
    value
  });
  const userClickContinueToWriteACheck = _ActionCreator.userClickContinueToWriteACheck = () => ({
    type: Action.Type.UserClickContinueToWriteACheck
  });
  const userClickCreatePrintableCheck = _ActionCreator.userClickCreatePrintableCheck = () => ({
    type: Action.Type.UserClickCreatePrintableCheck
  });
  const userClickDismissAuthModal = _ActionCreator.userClickDismissAuthModal = () => ({
    type: Action.Type.UserClickDismissAuthModal
  });
  const userClickDismissBillPayModal = _ActionCreator.userClickDismissBillPayModal = () => ({
    type: Action.Type.UserClickDismissBillPayModal
  });
  const userClickDismissPrintableCheckBlade = _ActionCreator.userClickDismissPrintableCheckBlade = () => ({
    type: Action.Type.UserClickDismissPrintableCheckBlade
  });
  const userClickDismissPrintableCheckModal = _ActionCreator.userClickDismissPrintableCheckModal = () => ({
    type: Action.Type.UserClickDismissPrintableCheckModal
  });
  const userClickDownloadCheck = _ActionCreator.userClickDownloadCheck = printableCheckId => ({
    type: Action.Type.UserClickDownloadCheck,
    printableCheckId
  });
  const userClickOpenCreatePrintableCheck = _ActionCreator.userClickOpenCreatePrintableCheck = () => ({
    type: Action.Type.UserClickOpenCreatePrintableCheck
  });
  const userClickHideEducation = _ActionCreator.userClickHideEducation = () => ({
    type: Action.Type.UserClickHideEducation
  });
  const userClickPayBills = _ActionCreator.userClickPayBills = () => ({
    type: Action.Type.UserClickPayBills
  });
  const userClickPrintCheck = _ActionCreator.userClickPrintCheck = printableCheckId => ({
    type: Action.Type.UserClickPrintCheck,
    printableCheckId
  });
  const userClickResendCode = _ActionCreator.userClickResendCode = () => ({
    type: Action.Type.UserClickResendCode
  });
  const userClickShowEducation = _ActionCreator.userClickShowEducation = () => ({
    type: Action.Type.UserClickShowEducation
  });
  const userClickStatementsAndDocuments = _ActionCreator.userClickStatementsAndDocuments = () => ({
    type: Action.Type.UserClickStatementsAndDocuments
  });
  const userClickSubmitAuthCode = _ActionCreator.userClickSubmitAuthCode = () => ({
    type: Action.Type.UserClickSubmitAuthCode
  });
  const userClickUploadBill = _ActionCreator.userClickUploadBill = () => ({
    type: Action.Type.UserClickUploadBill
  });
  const userClickWaitlist = _ActionCreator.userClickWaitlist = () => ({
    type: Action.Type.UserClickWaitlist
  });
  const userToggleAccountDetails = _ActionCreator.userToggleAccountDetails = () => ({
    type: Action.Type.UserToggleAccountDetails
  });
  const userUpdateCreatePrintableCheckRequest = _ActionCreator.userUpdateCreatePrintableCheckRequest = (field, value) => ({
    type: Action.Type.UserUpdateCreatePrintableCheckRequest,
    field,
    value
  });
})(ActionCreator || (ActionCreator = {}));